import React from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import GitHubIcon from '@mui/icons-material/GitHub';
import LaunchIcon from '@mui/icons-material/Launch';

import { projects } from '../data';

function Projects() {
  return (
    <Box sx={{ py: 1 }}>
      <Box sx={{ mb: 3.5, textAlign: 'center' }}>
        <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 800, color: '#00a2ff', fontFamily: "'Share Tech Mono', monospace" }}>
          [ Featured Security & Dev Projects ]
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: '500px', mx: 'auto', fontSize: '0.85rem' }}>
          A showcase of cybersecurity auditing tools, compliance scripts, and responsive web systems.
        </Typography>
      </Box>
      <Grid container spacing={2.5}>
        {projects.map((project, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card 
              sx={{ 
                height: '100%', 
                display: 'flex', 
                flexDirection: 'column',
                border: '1px solid #1c2536',
                background: '#0d1017',
                '&:hover img': {
                  transform: 'scale(1.03)',
                }
              }}
            >
              <Box sx={{ overflow: 'hidden', height: 130, position: 'relative' }}>
                <CardMedia
                  component="img"
                  height="130"
                  image={project.image}
                  alt={project.title}
                  sx={{ 
                    transition: 'transform 0.5s ease',
                    objectFit: 'cover'
                  }}
                />
                <Box 
                  sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    background: 'linear-gradient(to bottom, transparent 40%, rgba(8, 11, 16, 0.95))'
                  }}
                />
              </Box>
              <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', p: 2 }}>
                {/* Project Tags */}
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.6, mb: 1.5 }}>
                  {project.tags.map((tag) => (
                    <Chip 
                      key={tag} 
                      label={tag} 
                      size="small" 
                      sx={{ 
                        bgcolor: 'rgba(0, 162, 255, 0.05)', 
                        color: '#33b5ff', 
                        fontSize: '0.68rem',
                        fontWeight: 600,
                        border: '1px solid rgba(0, 162, 255, 0.15)',
                        height: 18,
                        '& .MuiChip-label': { px: 0.8 }
                      }} 
                    />
                  ))}
                </Box>
                
                <Typography gutterBottom variant="body1" component="h2" sx={{ fontWeight: 700, fontSize: '0.98rem', lineHeight: 1.3, color: '#ffffff', fontFamily: "'Share Tech Mono', monospace" }}>
                  {project.title}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5, fontSize: '0.8rem', lineHeight: 1.4 }}>
                  {project.description}
                </Typography>
              </CardContent>
              <Box sx={{ p: 2, pt: 0, display: 'flex', gap: 1 }}>
                <Button 
                  variant="contained" 
                  color="primary"
                  size="small" 
                  href={project.link} 
                  target="_blank"
                  endIcon={<LaunchIcon sx={{ fontSize: '0.8rem !important' }} />}
                  sx={{ flex: 1, py: 0.5, fontSize: '0.75rem' }}
                >
                  Launch App
                </Button>
                {project.github && (
                  <Button 
                    variant="outlined" 
                    color="inherit"
                    size="small" 
                    href={project.github} 
                    target="_blank"
                    startIcon={<GitHubIcon sx={{ fontSize: '0.8rem !important' }} />}
                    sx={{ 
                      flex: 1,
                      py: 0.5,
                      fontSize: '0.75rem',
                      borderColor: 'rgba(255,255,255,0.1)',
                      '&:hover': {
                        borderColor: '#ffffff',
                        bgcolor: 'rgba(255,255,255,0.04)'
                      }
                    }}
                  >
                    Source
                  </Button>
                )}
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default Projects;
